import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Container } from "@/components/shared";
import { Megaphone, Sparkles, BookOpen, Users, ArrowUpRight } from "lucide-react";

export default function Nouveautes() {
  const [changelog, setChangelog] = useState([]);
  const [version, setVersion] = useState("");
  const [books, setBooks] = useState([]);
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    api.get("/app/version").then(({ data }) => { setChangelog(data.changelog || []); setVersion(data.version || ""); }).catch(() => {});
    api.get("/books").then(({ data }) => setBooks((data.books || []).slice(0, 8))).catch(() => {});
    api.get("/partners").then(({ data }) => setPartners((data.partners || []).slice(0, 8))).catch(() => {});
  }, []);

  return (
    <Container>
      <div data-testid="nouveautes-page">
        <div className="mb-8">
          <div className="inline-flex items-center gap-2 text-gold text-xs uppercase tracking-[0.2em] mb-3">
            <Megaphone size={14} /> Nouveautés
          </div>
          <h1 className="font-display text-3xl sm:text-4xl font-light tracking-tight">
            Ce qui évolue sur <span className="gold-text">BIZARRE AI</span>
          </h1>
          <p className="text-white/55 text-sm sm:text-base mt-2">
            Nouvelles fonctionnalités, corrections, livres et partenaires — l'application grandit grâce à vous.
          </p>
        </div>

        {/* Journal des versions */}
        <section className="mb-12">
          <h2 className="font-display text-lg md:text-xl tracking-tight mb-4 flex items-center gap-2">
            <Sparkles size={18} className="text-gold" /> Journal des évolutions
          </h2>
          <div className="space-y-4">
            {changelog.map((c) => (
              <div key={c.version} className="card-surface p-5" data-testid={`changelog-${c.version}`}>
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs px-2.5 py-1 rounded-full gold-gradient text-black font-medium">v{c.version}</span>
                  {c.date && <span className="text-white/35 text-xs">{c.date}</span>}
                </div>
                <ul className="space-y-1.5">
                  {c.changes.map((ch, i) => (
                    <li key={i} className="text-white/75 text-sm flex gap-2">
                      <span className="text-gold mt-1.5 w-1 h-1 rounded-full bg-gold shrink-0" /> {ch}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            {changelog.length === 0 && <p className="text-white/30 text-sm">Bientôt les premières nouveautés.</p>}
          </div>
        </section>

        {/* Nouveaux livres */}
        {books.length > 0 && (
          <section className="mb-12">
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-display text-lg md:text-xl tracking-tight flex items-center gap-2">
                <BookOpen size={18} className="text-gold" /> Nouveaux livres
              </h2>
              <Link to="/bibliotheque" className="text-gold text-sm hover:underline inline-flex items-center gap-1">Tout voir <ArrowUpRight size={14} /></Link>
            </div>
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4">
              {books.map((b) => (
                <Link key={b.book_id} to={`/bibliotheque/${b.book_id}`} className="group" data-testid={`new-book-${b.book_id}`}>
                  <div className="aspect-[2/3] rounded-lg overflow-hidden border border-white/10 bg-white/[0.03]">
                    {b.image_url && <img src={b.image_url} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />}
                  </div>
                  <p className="text-white/80 text-xs mt-2 line-clamp-2">{b.title}</p>
                </Link>
              ))}
            </div>
          </section>
        )}

        {/* Nouveaux partenaires */}
        {partners.length > 0 && (
          <section className="mb-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-display text-lg md:text-xl tracking-tight flex items-center gap-2">
                <Users size={18} className="text-gold" /> Nouveaux partenaires
              </h2>
              <Link to="/partenaires" className="text-gold text-sm hover:underline inline-flex items-center gap-1">Tout voir <ArrowUpRight size={14} /></Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
              {partners.map((p) => (
                <Link key={p.partner_id} to={`/partenaires/${p.partner_id}`} className="card-surface p-4 flex items-center gap-3 hover:border-gold/30 transition-colors" data-testid={`new-partner-${p.partner_id}`}>
                  <div className="w-11 h-11 rounded-full overflow-hidden bg-white/[0.05] shrink-0">
                    {p.image_url && <img src={p.image_url} alt={p.name} className="w-full h-full object-cover" />}
                  </div>
                  <div className="min-w-0">
                    <p className="text-white/85 text-sm truncate">{p.name}</p>
                    <p className="text-white/40 text-xs truncate">{p.role}</p>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        )}
      </div>
    </Container>
  );
}
